import cloneDeep from 'lodash/cloneDeep';
import { Events } from '../enums/events.enum';
import { FormTypes } from '../enums/form-type.enum';
import { Names } from '../enums/names.enum';
import { YesNo } from '../enums/yes-no.enum';
import { IDataLayer } from '../interfaces/data-layer.interface';
import { DataLayerForm } from './data-layer-form.model';
import { History } from './history.model';
import { Message } from './message.model';

export class DataLayer implements IDataLayer {
    'event': Events;
    'policyNumber': string;
    'form'?: DataLayerForm;
    'history'?: History;
    'messages'?: Message;
    'user'?: any;
    'errors'?: YesNo;

    [key: string]: any;

    constructor(dataLayer?: IDataLayer) {
        if (dataLayer) {
            Object.assign(this, dataLayer);
        }
    }

    setEvent(event: Events) {
        this.event = event;
        return this;
    }

    setPolicyNumber(policyNumber: string) {
        this.policyNumber = policyNumber;
        return this;
    }

    setForm(form: DataLayerForm) {
        this.form = form;
        return this;
    }

    setFormStepName(stepName: string) {
        this.form.stepName = stepName;
        return this;
    }

    setFormName(name: Names) {
        this.form.name = name;
        return this;
    }

    setFormType(type: FormTypes) {
        this.form.type = type;
        return this;
    }

    setHistory(history: History) {
        this.history = history;
        return this;
    }

    setMessages(messages: Message) {
        this.messages = messages;
        return this;
    }

    setCustomProperty(property: any, value: any) {
        this[property] = value;
        return this;
    }

    setUser(user: any) {
        this.user = user;
        return this;
    }

    setErrors(errors: YesNo) {
        this.errors = errors;
        return this;
    }

    getLayers(): Array<any> {
        return (window as any).dataLayer || [];
    }

    submit() {
        if (window) {
            (window as any).dataLayer = (window as any).dataLayer || [];
            if (this) {
                (window as any).dataLayer.push(cloneDeep(this));
            }
        }
        return this;
    }
}
